import { createApplication, provideClientHydration } from '@angular/platform-browser';
import { createCustomElement } from '@angular/elements';
import { HttpClient, provideHttpClient } from '@angular/common/http';
import 'zone.js';
import { CustomDateAdapter } from './app/datepicker-inline-calendar/custom-date-adapter';
import { importProvidersFrom, LOCALE_ID } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { environment } from './environments/environment';
import { DatePipe } from '@angular/common';
import { DateAdapter, MatNativeDateModule } from '@angular/material/core';
import { OverlayContainer } from '@angular/cdk/overlay';
import { CustomOverlayContainer } from './app/booking-widget/custom-overlay-container';
import { AppComponent } from './app/app.component';
import { CustomDateAdapterTransfer } from './app/datepicker-inline-calendar/custom-date-adapter-transfer';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, environment.translationUrl + 'assets/i18n/', '.json');
}

createApplication({
  providers: [
    provideHttpClient(),
    provideClientHydration(),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      })
    ),
    provideAnimationsAsync(),
    importProvidersFrom(MatNativeDateModule),
    DatePipe,
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: OverlayContainer, useClass: CustomOverlayContainer }
  ],
})
  .then((app) => {
    const AppComponentInstance = createCustomElement(AppComponent, { injector: app.injector });
    if (!customElements.get('booking-widget')) {
      customElements.define('booking-widget', AppComponentInstance);
    }
  })
  .catch((err) => console.error(err));


createApplication({
  providers: [
    provideHttpClient(),
    // provideClientHydration(),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      })
    ),
    provideAnimationsAsync(),
    importProvidersFrom(MatNativeDateModule),
    DatePipe,
    { provide: DateAdapter, useClass: CustomDateAdapterTransfer },
    { provide: OverlayContainer, useClass: CustomOverlayContainer }
  ],
})
  .then((app) => {
    const AppComponentInstance = createCustomElement(AppComponent, { injector: app.injector });
    if (!customElements.get('booking-widget-transfer')) {
      customElements.define('booking-widget-transfer', AppComponentInstance);
    }
  })
  .catch((err) => console.error(err));